import React from 'react';
import { Button } from '../ui/button';
import { BoxIcon } from 'lucide-react';
interface EmptyStateProps {
  icon: BoxIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}
export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center py-12 px-4 text-center border rounded-lg border-dashed bg-slate-50/50" data-id="element-79">
      <div className="h-12 w-12 rounded-full bg-slate-100 flex items-center justify-center mb-4" data-id="element-80">
        <Icon className="h-6 w-6 text-slate-400" data-id="element-81" />
      </div>
      <h3 className="text-lg font-semibold text-slate-900 mb-1" data-id="element-82">{title}</h3>
      <p className="text-sm text-slate-500 max-w-sm mb-6" data-id="element-83">{description}</p>
      {actionLabel && onAction && <Button onClick={onAction} data-id="element-84">{actionLabel}</Button>}
    </div>;
}